import React from 'react';
import { useSelector } from 'react-redux';

import Interior360 from '../sections/interior-360/interior-360';

import { getActiveTab } from '../store/car-slice';
import { getShowVideo } from '../store/car-slice';

import VideoPlayer from '../components/video-player/video-player';
import InteriorCamera from '../sections/interior-camera/interior-camera';
import GalleryContainer from '../sections/gallery/gallery-container';
import { Box, Fade } from '@mui/material';

import { urlParam } from '../utils/url-param';
import Buttons from '../sections/buttons/buttons';

// device => gadget or camera
const device = urlParam('device');

export default function CarFeatures() {
  // Selectors
  const activeTab = useSelector(getActiveTab);

  const showVideo = useSelector(getShowVideo);

  const renderTabContent = (
    <>
      {activeTab?.includes('interior') && device === 'gadget' && (
        <Interior360 />
      )}

      {activeTab?.includes('interior') && device === 'camera' && (
        <InteriorCamera />
      )}

      <Box
        sx={{
          display: activeTab === 'gallery' ? 'flex' : 'none',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <GalleryContainer />
      </Box>
    </>
  );

  return (
    <>
      <Box
        sx={{
          position: activeTab !== 'exterior' ? 'fixed' : 'initial',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      >
        {renderTabContent}
        {activeTab !== 'exterior' && <Buttons />}
      </Box>

      <Fade in={showVideo}>
        <Box>
          <VideoPlayer />
        </Box>
      </Fade>
    </>
  );
}
